"use client";

import { useEffect, useRef } from "react";

type LenisProviderProps = {
  children: React.ReactNode;
};

export default function LenisProvider({ children }: LenisProviderProps) {
  const rafId = useRef<number>(0);

  useEffect(() => {
    let lenis: { raf: (time: number) => void; destroy: () => void } | null = null;

    const init = async () => {
      const Lenis = (await import("lenis")).default;
      lenis = new Lenis({
        duration: 1.2,
        easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
      });

      const raf = (time: number) => {
        lenis?.raf(time);
        rafId.current = requestAnimationFrame(raf);
      };
      rafId.current = requestAnimationFrame(raf);
    };

    init();

    return () => {
      cancelAnimationFrame(rafId.current);
      lenis?.destroy();
    };
  }, []);

  return <>{children}</>;
}
